var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.104 4.359c-.927 0-1.589.155-2.045.337-.228.091-.4.188-.526.271a2 2 0 0 0-.224.176l-.009.008-.004.004-.001.002h-.001s-.001.001.588.59l-.59-.589a.83.83 0 0 0-.243.59v10.555a.833.833 0 1 0 1.666 0v-3.407c.247-.093.687-.204 1.39-.204.65 0 1.203.212 1.912.496l.043.017c.672.269 1.494.598 2.489.598.927 0 1.59-.155 2.045-.337.228-.091.4-.188.527-.271a2 2 0 0 0 .224-.176l.008-.008.004-.004.002-.002c0-.001.001-.002-.588-.59l.59.589a.83.83 0 0 0 .243-.59V5.748a.833.833 0 0 0-1.408-.607c-.03.02-.1.063-.22.11-.239.096-.688.219-1.427.219-.65 0-1.203-.212-1.913-.496l-.043-.017c-.671-.27-1.494-.598-2.489-.598m-1.389 6.805V6.229c.247-.093.687-.204 1.39-.204.65 0 1.203.213 1.912.496l.043.017c.672.27 1.494.599 2.489.599.553 0 1.012-.056 1.389-.139v4.935c-.247.093-.687.204-1.39.204-.65 0-1.202-.213-1.912-.496l-.043-.018c-.671-.268-1.494-.598-2.489-.598-.553 0-1.011.056-1.389.139"
  })));
};
export default SvgFlag;